export const SET_LAYOUT = 'events/SET_LAYOUT';

/**
 * @param payload
 * @returns {{payload: *, type: string}}
 */
export const setLayout = (payload) => ({ type: SET_LAYOUT, payload });
